<template>
  <div class="pt-100 mb-pt-60">
      <div class="container">
    <div class="relative mb-5">
      <img class="absolute br-14 z-2 top-p-50 left-0 right-0 trans-y-50  img-cover" src="https://s3-cdn.designerjourneys.com/static/images/howitworks/bg-explore.jpg" alt="banner">
      <div class="relative z-3 pt-100 pb-110 mb-pt-60 mb-pb-60 mb-pl-30 mb-pr-30 pl-80 pr-80 flex flex-column items-end">
        <div class="w-371 mb-tr">
          <h2 class="fs-36 mb-fs-28 fw-900 mb-20 mb-mb-28 white">Begin Your Journey</h2>
          <p class="fs-16 lh-24 mb-30 mb-mb-24 dib white maxw-400 mb-w-190">
            Wherever you're looking to travel, our Local Designers will design an extraordinary travel experience completely tailored to you. Begin your journey by exploring our gallery today!
          </p>
          <p class="mb-0">
            <router-link
              :to="{ name: 'trip-gallery' }"
              class="button button-green"
              title="Go to page: Explore Our Gallery"
              aria-label="Go to page: Explore Our Gallery"
              @click="setGallerySource"
            >
              Explore Our Gallery
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script setup>
// import { defineProps } from 'vue'
import { useHeapStore } from '~/store/pinia/heap'
const props = defineProps({
  heapSource: {
    type: String,
    default: 'external_link',
  },
})
const heapStore = useHeapStore()
const setGallerySource = async () => {
  await heapStore.changeGalleryHeap(props.heapSource)
}
</script>
